export const generateID = () => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 10);
  const id = `${timestamp}-${random}`;
  return id;
};


export const compList = [
  {
    id: generateID(),
    url: "https://cdn0.iconfinder.com/data/icons/phosphor-thin-vol-2/256/chart-line-thin-512.png",
    component: "LineChart",
    checked: false,
  },
  {
    id: generateID(),
    url: "https://cdn0.iconfinder.com/data/icons/phosphor-thin-vol-2/256/chart-bar-thin-512.png",
    component: "BarChart",
    checked: false,
  },
  {
    id: generateID(),
    url: "https://cdn0.iconfinder.com/data/icons/phosphor-thin-vol-2/256/chart-pie-thin-512.png",
    component: "PieChart",
    checked: false,
  },
  {
    id: generateID(),
    url: "https://cdn0.iconfinder.com/data/icons/phosphor-thin-vol-1/256/chart-bar-horizontal-thin-512.png",
    component: "BulletChart",
    checked: false,
  },
  {
    id: generateID(),
    url: "https://cdn0.iconfinder.com/data/icons/phosphor-thin-vol-3/256/lifebuoy-thin-512.png",
    component: "DoughnutChart",
    checked: false,
  },
  {
    id: generateID(),
    url: "https://cdn0.iconfinder.com/data/icons/phosphor-thin-vol-2/256/clipboard-text-thin-512.png",
    component: "ToDoList",
    checked: false,
  },
];


export const convertToArgentinaTime = (dateStr) => {
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat("es-AR", {
    timeZone: "America/Argentina/Buenos_Aires",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23", // 🔹 Asegura formato 24h
  }).format(date);
};


export const findHighestBoardNumber = (board) => {
  const existingBoardNumbers = Object.keys(board).map((boardName) =>
    parseInt(boardName.replace("board", ""), 10)
  );
  return Math.max(...existingBoardNumbers);
};


export const paramTagToMeasureType = {
  corriente: "corriente",
  tension: "tension",
  "potencia activa": "potActiva",
  "potencia reactiva": "potReactiva",
  "energia activa": "eActiva",
  "energia inductiva": "eReactiva",
};

export const formatAxisLabelEvolution = (value) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  const day = d.getDate();
  const hour = String(d.getHours()).padStart(2, "0");

  const monthNames = [
    "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"
  ];
  const month = monthNames[d.getMonth()];

  return `${day} de ${month} ${hour}hs`;
};

export const normalizeTimestampToMs = (input) => {
  if (input == null) return NaN;
  if (typeof input === "number") return input;
  if (input instanceof Date) return Number.isNaN(input.getTime()) ? NaN : input.getTime();

  if (typeof input === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      const [y, m, d] = input.split("-").map(Number);
      const dt = new Date(y, m - 1, d, 0, 0, 0, 0);
      return Number.isNaN(dt.getTime()) ? NaN : dt.getTime();
    }

    const parsed = Date.parse(input);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  return NaN;
};

export const inferSlotMsFromTsList = (tsList) => {
  if (!Array.isArray(tsList) || tsList.length < 3) return 30 * 60000;

  const diffs = [];
  for (let i = 1; i < tsList.length; i++) {
    const d = tsList[i] - tsList[i - 1];
    if (d > 0 && d < 12 * 3600000) diffs.push(d);
  }
  if (!diffs.length) return 30 * 60000;

  diffs.sort((a, b) => a - b);
  return diffs[Math.floor(diffs.length / 2)];
};

export const periodLabel = (period) => (period === "base" ? "Periodo base" : `Periodo ${period}`);

export const formatLegendDateDMY = (date) => {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const isFiniteNumber = (v) => Number.isFinite(Number(v));

export const dedupeByTimestamp = (rows) => {
  const m = new Map();
  rows.forEach((r) => {
    const ts = normalizeTimestampToMs(r?.timestamp);
    if (!Number.isFinite(ts)) return;

    const prev = m.get(ts);
    if (!prev) {
      const n = { ...r, ts };
      m.set(ts, n);
      return;
    }

    const next = { ...prev, ...r, ts };
    Object.keys(next).forEach((k) => {
      if (next[k] === undefined || next[k] === null) delete next[k];
    });
    m.set(ts, next);
  });

  return Array.from(m.values()).sort((a, b) => a.ts - b.ts);
};

export const pickReferencePeriod = (all) => {
  const order = ["base", "1", "2", "3"];
  for (const p of order) {
    if (all.some((it) => it.period === p && it.formatted?.length)) return p;
  }
  return null;
};

export const filterTimelineByHour = (timeline, mode, hour) => {
  if (mode !== "hour") return timeline;
  const targetH = Number(hour);
  return timeline.filter((ts) => new Date(ts).getHours() === targetH);
};

export const clampToFinite = (x, fallback) => (Number.isFinite(x) ? x : fallback);

export const getRangeMs = (periodDateRanges, period) => {
  const [s, e] = periodDateRanges?.[period] || [null, null];
  const sMs = normalizeTimestampToMs(s);
  const eMs = normalizeTimestampToMs(e);
  return {
    start: Number.isFinite(sMs) ? sMs : null,
    end: Number.isFinite(eMs) ? eMs : null,
  };
};

export const buildTimelineUniform = (startMs, endMs, slotMs) => {
  const out = [];
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs) || !Number.isFinite(slotMs) || slotMs <= 0) {
    return out;
  }
  for (let t = startMs; t <= endMs; t += slotMs) out.push(t);
  return out;
};

export const buildIndexAggAvg = (formatted, keyName, slotMs, periodStartMs) => {
  const acc = new Map();

  formatted.forEach((d) => {
    const v = Number(d[keyName]);
    if (!Number.isFinite(v)) return;

    const idx = Math.round((d.ts - periodStartMs) / slotMs);
    if (!Number.isFinite(idx)) return;

    const prev = acc.get(idx);
    if (!prev) acc.set(idx, { sum: v, count: 1 });
    else {
      prev.sum += v;
      prev.count += 1;
    }
  });

  const out = new Map();
  acc.forEach((v, idx) => out.set(idx, v.sum / v.count));
  return out;
};

export const formatOnlyHour = (value) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm} hs`;
};

export const formatARDateTime = (msOrDate) => convertToArgentinaTime(msOrDate);

export const formatARTime = (msOrDate) =>
  new Intl.DateTimeFormat("es-AR", {
    timeZone: "America/Argentina/Buenos_Aires",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(new Date(msOrDate));

export const formatHHMM = (value, baseEpoch = Date.UTC(2000, 0, 1)) => {
  const totalMin = Math.max(0, Math.round((value - baseEpoch) / 60000));
  const hh = String(Math.floor(totalMin / 60)).padStart(2, "0");
  const mm = String(totalMin % 60).padStart(2, "0");
  return `${hh}:${mm}`;
};